import React from 'react';
import { FaPhone, FaEnvelope, FaClock, FaMapMarkerAlt, FaCheckCircle, FaRocket, FaUsers, FaChartLine } from 'react-icons/fa';
import './Contato.css';

const Contato = () => {
  return (
    <div className="suporte-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">ProcessStepWise</h1>
          <p className="hero-subtitle">Sistema Inteligente de Gestão Industrial</p>
          <div className="hero-badge">Transformando Processos em Resultados</div>
        </div>
      </section>

      {/* Apresentação do Sistema */}
      <section className="about-section">
        <div className="about-content">
          <h2 className="section-title">Bem-vindo ao ProcessStepWise</h2>
          <p className="about-description">
            O ProcessStepWise é uma solução completa e inovadora para gestão industrial, 
            desenvolvida para otimizar processos, aumentar a produtividade e 
            proporcionar controle total sobre suas operações.
          </p>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <FaRocket />
              </div>
              <h3>Eficiência Máxima</h3>
              <p>Automatize processos e reduza tempo de produção com ferramentas inteligentes</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FaChartLine />
              </div>
              <h3>Análise em Tempo Real</h3>
              <p>Dashboards e relatórios completos para decisões estratégicas baseadas em dados</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FaUsers />
              </div>
              <h3>Gestão Integrada</h3>
              <p>Controle completo de fornecedores, matéria-prima, produtos e qualidade</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FaCheckCircle />
              </div>
              <h3>Qualidade Garantida</h3>
              <p>Sistema de controle de qualidade com cronoanálise e testes de calce</p>
            </div>
          </div>
        </div>
      </section>

      {/* Módulos do Sistema */}
      <section className="modules-section">
        <h2 className="section-title">Módulos do Sistema</h2>
        <div className="modules-list">
          <div className="module-item">
            <span className="module-bullet">•</span>
            <span>Gestão de Fornecedores</span>
          </div>
          <div className="module-item">
            <span className="module-bullet">•</span>
            <span>Controle de Matéria-Prima</span>
          </div>
          <div className="module-item">
            <span className="module-bullet">•</span>
            <span>Cadastro de Produtos e Ficha Técnica</span>
          </div>
          <div className="module-item">
            <span className="module-bullet">•</span>
            <span>Cronoanálise de Processos</span>
          </div>
          <div className="module-item">
            <span className="module-bullet">•</span>
            <span>Controle de Qualidade</span>
          </div>
          <div className="module-item">
            <span className="module-bullet">•</span>
            <span>Gestão de Perfis e Usuários</span>
          </div>
          <div className="module-item">
            <span className="module-bullet">•</span>
            <span>Sistema MES (Manufacturing Execution System)</span>
          </div>
          <div className="module-item">
            <span className="module-bullet">•</span>
            <span>Catálogo Virtual de Produtos</span>
          </div>
        </div>
      </section>

      {/* Seção de Contato */}
      <section className="contact-section">
        <h2 className="section-title">Entre em Contato</h2>
        <p className="contact-description">
          Nossa equipe está pronta para ajudar você a aproveitar ao máximo o ProcessStepWise.
          Entre em contato conosco através dos canais abaixo:
        </p>

        <div className="contact-cards">
          <div className="contact-card">
            <div className="contact-icon">
              <FaEnvelope />
            </div>
            <h3>E-mail</h3>
            <p className="contact-info">processwisesistem@outlook.com</p>
            <p className="contact-subtext">Respondemos em até 24 horas</p>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <FaPhone />
            </div>
            <h3>Telefone</h3>
            <p className="contact-info">(31) 9 7537-4852</p>
            <p className="contact-subtext">Seg a Sex, 8h às 18h</p>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <FaClock />
            </div>
            <h3>Horário de Atendimento</h3>
            <p className="contact-info">Segunda a Sexta</p>
            <p className="contact-subtext">08:00 às 18:00</p>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <FaMapMarkerAlt />
            </div>
            <h3>Localização</h3>
            <p className="contact-info">Nova Serrana - MG</p>
            <p className="contact-subtext">Brasil</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="suporte-footer">
        <p>&copy; 2025 ProcessStepWise - Todos os direitos reservados</p>
        <p className="footer-tagline">Inovação e Eficiência para sua Indústria</p>
      </footer>
    </div>
  );
};

export default Contato;